import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderStatus } from '../../constants/KRollConstants';
import { HelperService } from '../../services/helper.service';
import { KRollService } from '../../services/api-services/kroll.service';
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {

  optionList: any = [];
  showOptionCode: any = [];
  discoverServiceList: any = [];
  serviceCode: any;

  constructor(public dialogRef: MatDialogRef<SummaryComponent>,
    public helperService: HelperService,
    public krollService: KRollService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.get_options()
    this.get_discover_services_general()
  }
  getPaymentType() {
    let status: any = {
      [OrderStatus.Unpaid]: () => "Pending",
      [OrderStatus.NoDues]: () => "No dues",
      [OrderStatus.Paid]: () => {
        return "Paid" // Return Source of payment
      },
    }
    return status[this.props.SalesOrderStatus].call(this.props) ?? "";
  }
  get paymentDue() {
    return (this.props.SalesOrderStatus == OrderStatus.Paid) ? 0 : this.props.PaymentDue;
  }
  get_options() {
    let payload: any = {
      "Locale": "EN"
    }
    this.krollService.get_options(payload).subscribe((res: any) => {
      if (res) {
        this.optionList = res.body.data
        if (this.props?.OptionCode) {
          let filteredArray = this.optionList.filter((element: any) => this.props?.OptionCode.includes(element.OptionCode));
          filteredArray.map((item: any) => {
            this.showOptionCode.push(item.OptionName)
          })
        }
      }
    })
  }

  get_discover_services_general() {
    let payload: any = {
      "CountryCode": "CA",
      "Locale": "EN",
    };
    this.krollService.get_discover_services(payload).subscribe((res: any) => {
      if (res) {
        this.discoverServiceList = res.body.data
        if (this.props?.ServiceCode) {
          let filteredArray = this.discoverServiceList.find((element: any) => element.ServiceCode == this.props?.ServiceCode).ServiceName;
          this.serviceCode = filteredArray
        }

      }
    },
      (error: any) => {
      }
    )
  }
}
